import React from 'react';
import jedaiLogo from '../../assets/logo_JedAI.svg';
import ciscoLogo from '../../assets/cisco-logo.png';

// =====================================================================
// DECOMMISSIONED — Application is no longer in service (17 July 2026)
// Original login page code commented out below.
// =====================================================================

const LoginPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#0F1923',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
      className="flex flex-col items-center justify-center px-4"
    >
      <div style={{ maxWidth: '560px', width: '100%' }}>
        {/* JedAI logo — invert dark fills to white, hue-rotate to preserve blue */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <img
            src={jedaiLogo}
            alt="JedAI"
            style={{
              height: '64px',
              width: 'auto',
              margin: '0 auto',
              filter: 'invert(1) hue-rotate(180deg)',
            }}
          />
        </div>

        {/* Status chip */}
        <div style={{ marginBottom: '32px', textAlign: 'center' }}>
          <span
            style={{
              display: 'inline-block',
              padding: '6px 16px',
              border: '1px solid #C2362E',
              borderRadius: '4px',
              color: '#E8453C',
              fontSize: '11px',
              fontFamily: "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
              fontWeight: 500,
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            Status: Decommissioned
          </span>
        </div>

        {/* Heading */}
        <h1
          style={{
            color: '#E8ECF1',
            fontSize: '36px',
            fontWeight: 600,
            textAlign: 'center',
            margin: '0 0 16px 0',
            lineHeight: 1.2,
            letterSpacing: '-0.5px',
          }}
        >
          This application has been
          <br />
          decommissioned
        </h1>

        {/* Red divider */}
        <div
          style={{
            width: '48px',
            height: '2px',
            backgroundColor: '#E8453C',
            margin: '0 auto 32px auto',
            borderRadius: '1px',
          }}
        />

        {/* Body copy */}
        <p
          style={{
            color: '#7B8FA3',
            fontSize: '15px',
            lineHeight: 1.7,
            textAlign: 'center',
            margin: '0 0 36px 0',
          }}
        >
          JedAI is no longer in service.
          All backend systems, databases, and integrations have been shut down.
          No new sign-ins are being accepted.
        </p>

        {/* Details panel */}
        <div
          style={{
            backgroundColor: '#1A2736',
            border: '1px solid #2A3A4D',
            borderRadius: '8px',
            padding: '24px 28px',
            marginBottom: '36px',
          }}
        >
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              {[
                ['Effective Date', '17 July 2026'],
                ['Application', 'JedAI'],
              ].map(([label, value], i, arr) => (
                <tr key={label}>
                  <td
                    style={{
                      color: '#546A7F',
                      fontSize: '13px',
                      fontWeight: 500,
                      padding: '10px 0',
                      letterSpacing: '0.3px',
                      borderBottom: i < arr.length - 1 ? '1px solid #2A3A4D' : 'none',
                      whiteSpace: 'nowrap',
                      width: '140px',
                    }}
                  >
                    {label}
                  </td>
                  <td
                    style={{
                      color: '#C5CED8',
                      fontSize: '13px',
                      padding: '10px 0',
                      textAlign: 'right',
                      borderBottom: i < arr.length - 1 ? '1px solid #2A3A4D' : 'none',
                    }}
                  >
                    {value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Cisco logo footer */}
        <div style={{ textAlign: 'center' }}>
          <img
            src={ciscoLogo}
            alt="Cisco"
            style={{
              height: '64px',
              width: 'auto',
              margin: '0 auto',
              opacity: 0.5,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;

// =====================================================================
// ORIGINAL LOGIN PAGE (commented out — do not remove)
// =====================================================================
//
// import React from 'react';
// import { useAuth } from '../../contexts/AuthContext';
// import ciscoLogo from '../../assets/cisco_corporate_strategy_ai_white_text.svg';
//
// const LoginPage: React.FC = () => {
//   const { login, isLoading, error } = useAuth();
//
//   const handleLogin = async () => {
//     try {
//       await login();
//     } catch (error) {
//       console.error('Login error:', error);
//     }
//   };
//
//   return (
//     <div
//       style={{
//         minHeight: '100vh',
//         backgroundImage: 'url("/loginpage_bgimg.jpg")',
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         backgroundRepeat: 'no-repeat',
//       }}
//       className="flex flex-col justify-center py-12 sm:px-6 lg:px-8"
//     >
//       <div className="sm:mx-auto sm:w-full sm:max-w-md">
//       <div className="flex justify-center">
//         <img
//           // className="h-[80px] w-auto"
//           src={ciscoLogo}
//           alt="Cisco"
//         />
//       </div>
//         {/* <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
//           Sign in to Cisco AI Assistant
//         </h2> */}
//         <p className="mt-2 text-center text-sm text-gray-400">
//           Use your Cisco credentials for secure access.
//         </p>
//       </div>
//
//       <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
//         <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
//           {error && (
//             <div className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
//               {error}
//             </div>
//           )}
//
//           <div>
//             <button
//               onClick={handleLogin}
//               disabled={isLoading}
//               className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {isLoading ? (
//                 <div className="flex items-center">
//                   <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Signing in...
//                 </div>
//               ) : (
//                 'Sign in with Cisco SSO'
//               )}
//             </button>
//           </div>
//
//           <div className="mt-6">
//             <div className="relative">
//               <div className="absolute inset-0 flex items-center">
//                 <div className="w-full border-t border-gray-300" />
//               </div>
//               <div className="relative flex justify-center text-sm">
//                 <span className="px-2 bg-white text-gray-500">
//                   Secure authentication powered by Duo
//                 </span>
//               </div>
//             </div>
//           </div>
//
//           <div className="mt-6 text-center">
//             <p className="text-xs text-gray-500">
//               By signing in, you agree to Cisco's terms of service and privacy policy.
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
//
// export default LoginPage;
